<template>
  <div>
    <el-button
      v-show="pageStack.length > 1"
      type="warning"
      class="btn-back"
      @click="back"
    >
      <i class="icon-undo2"></i>
      {{
        pageStack[pageStack.length - 1] === 3 ? '返回栏目主页' : '上一页'
      }}</el-button
    >
    <commonDisease
      v-show="pageStack[pageStack.length - 1] === 0"
      tab-name="CommonDisease"
      :baby-search-id="babySearchId"
      :baby-id="id"
      @next="next"
    ></commonDisease>
    <diseaseDetail
      v-show="pageStack[pageStack.length - 1] === 1"
      :id="id"
      :is-reset-page-stack.sync="isResetPageStack"
      @back="back"
      @next="next"
    ></diseaseDetail>
    <advisoryDetail
      v-show="pageStack[pageStack.length - 1] === 2"
      :id="id"
      :record_id="record_id"
      :status="status"
      @next="next"
    ></advisoryDetail>
    <advisoryDetailRes
      v-if="pageStack[pageStack.length - 1] === 3"
      :id="id"
      :record_id="record_id"
    ></advisoryDetailRes>
  </div>
</template>
<script>
import _ from 'lodash';
import commonDisease from '@/components/advisory/commonDisease';
import diseaseDetail from '@/components/advisory/diseaseDetail/diseaseDetail';
import advisoryDetail from '@/components/advisory/advisoryDetail/advisoryDetail';
import advisoryDetailRes from '@/components/advisory/advisoryDetail/advisoryDetailRes';

export default {
  components: {
    commonDisease,
    diseaseDetail,
    advisoryDetail,
    advisoryDetailRes
  },
  props: {
    activeName: {
      type: Object,
      default: () => ({
        nav: '0',
        params: {}
      })
    }
  },
  data() {
    return {
      pageStack: [0],
      babySearchId: 0,
      id: '',
      record_id: '',
      onlyResult: false,
      isResetPageStack: false,
      status: ''
    };
  },
  watch: {
    'activeName.nav': {
      handler() {
        if (this.activeName.nav === '3') {
          this.id = this.activeName.params.babyId;
          this.record_id = this.activeName.params.recordId;
          this.next({}, 3);
          this.onlyResult = true;
        }
      },
      immediate: true
    },
    'activeName.params.babyId': {
      handler() {
        if (this.activeName.params.babyId) {
          this.id = this.activeName.params.babyId;
        }
      },
      immediate: true
    }
  },
  methods: {
    clearData() {
      this.id = 0;
      this.recordId = '';
      this.onlyResult = false;
    },
    next(data, index, ls) {
      this.onlyResult = false;
      this.status = ls;
      if (index === 1) {
        this.id = data.id;
      }
      if (index === 2) {
        this.record_id = +data.record_id;
      }

      this.pageStack.push(index);
    },
    back() {
      if (this.pageStack[this.pageStack.length - 1] === 3) {
        this.activeName.nav = null;
        this.pageStack = [0];
        this.id = 0;
        this.isResetPageStack = true;
        this.babySearchId = _.uniqueId();
        return;
      }
      this.pageStack.pop();
      if (this.pageStack[this.pageStack.length - 1] === 0) {
        this.id = 0;
        this.babySearchId = _.uniqueId();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-back {
  position: absolute;
  top: -68px;
  right: 30px;
  font-size: 16px;
  border-radius: 25px;
  padding: 7px 12px;
}
</style>
<style lang="scss">
.el-tabs__content {
  overflow: visible;
}
</style>
